module.exports = __webpack_public_path__ + "src/assets/img/light_turn_r.d5c9a7ce.svg";